import React from 'react';
import Txt from 'components/atoms/Txt/Txt';
import Image from 'components/atoms/Image/Image';
import { FAQ } from 'components/pages/pages';
import useLocalisedImage from 'hooks/useLocalisedImage';
import aboutImg1 from './assets/about_img_1.png';
import aboutImg1_en_gb from './assets/about_img_1_en-gb.png';
import aboutImg2 from './assets/about_img_2.png';
import aboutImg3 from './assets/about_img_3.png';
import aboutImg3_de_de from './assets/about_img_3_de-de.png';
import aboutImg3_fr_fr from './assets/about_img_3_fr-fr.png';
import aboutImg4 from './assets/about_img_4.png';
import aboutImg5 from './assets/about_img_5.png';
import SplitRow from 'components/organisms/SplitRow/SplitRow';
import FullWidthCta from 'components/organisms/FullWidthCta/FullWidthCta';

export interface Props {}

const About: React.FC<Props> = () => {
  const localisedImage = useLocalisedImage();

  return (
    <main className="fadedPageBg">
      <SplitRow
        contentAlignedTop
        mobileColumnOrderSwapped
        isFirstRow
        leftColumn={
          <>
            <Txt component="h1">About Us</Txt>
            <Txt component="h2">Our Mission</Txt>
            <Txt component="p">
              At Qmee, our mission is to provide a free, easy-to-use platform that enables a
              community of change-makers to get paid for their opinions! To do this, our team works
              together to push the boundaries of what a survey platform can be, whilst making sure
              our users are treated fairly and prioritising data protection.
            </Txt>
          </>
        }
        rightColumn={
          <Image
            src={localisedImage({ global: aboutImg1, 'en-gb': aboutImg1_en_gb })}
            alt="Our Mission"
          />
        }
      />

      <SplitRow
        rightColumn={
          <>
            <Txt component="h2">Our Drive</Txt>
            <Txt component="p">
              Enabling our users to have the best Qmee experience is at the heart of what we do.
              We&apos;ve always got our ear to the ground to find out how we can make a better,
              faster and more entertaining platform. Improving features and coming up with new ideas
              is key to life at Qmee!
            </Txt>
          </>
        }
        leftColumn={<Image src={aboutImg2} alt="Our Drive" />}
      />

      <SplitRow
        mobileColumnOrderSwapped
        leftColumn={
          <>
            <Txt component="h2">Our team</Txt>
            <Txt component="p">
              Creating a community of change-makers is no small feat and it can&apos;t be done
              alone. We&apos;re a team of problem solvers and innovators, with skills ranging from
              software engineering and data science to design. We collaborate cross-functionally
              with the shared goal of creating an engaging and rewarding Qmee experience!
            </Txt>
          </>
        }
        rightColumn={
          <Image
            src={localisedImage({
              global: aboutImg3,
              'de-de': aboutImg3_de_de,
              'fr-fr': aboutImg3_fr_fr,
            })}
            alt="Our team"
          />
        }
      />

      <SplitRow
        rightColumn={
          <>
            <Txt component="h2">Our People</Txt>
            <Txt component="p">
              Diversity is the key within any community and we&apos;re proud to say that Qmee
              crosses borders both for our users and within our teams. The Qmee team comes from more
              than 30 countries, over half of our employees are women or people of color and women
              are represented at all levels of company leadership.
            </Txt>
          </>
        }
        leftColumn={<Image src={aboutImg4} alt="Our People" />}
      />

      <SplitRow
        mobileColumnOrderSwapped
        leftColumn={
          <>
            <Txt component="h2">Our Culture</Txt>
            <Txt component="p">
              Working at Qmee, we&apos;re learners first. We strive for daily progress and celebrate
              the small wins as a team! We collaborate with kindness and find continuous connection
              through our passion for exploring new things.
            </Txt>
          </>
        }
        rightColumn={<Image src={aboutImg5} alt="Our Culture" />}
      />

      <FullWidthCta
        title={<Txt>Frequently Asked Questions</Txt>}
        ctaText="FAQ's"
        ctaLink={FAQ.path}
      >
        Check out our FAQ&apos;s to help with any unanswered questions
      </FullWidthCta>
    </main>
  );
};
export default About;
